import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import VideoHero from '../components/shared/VideoHero';

const Course = () => {
  // Stripe Linki
  const checkoutUrl = "https://buy.stripe.com/9B68wQefM536eBY39R9oc0F";

  return (
    <>
      <Helmet>
        <title>Picture Book Course | Little Hibba</title>
        <meta 
          name="description" 
          content="A 6-week guided course designed to assist you in writing, editing, and publishing your children’s picture book." 
        />
      </Helmet>

      {/* 1. Hero Bölümü */}
      <VideoHero 
        title="Picture Book Course" 
        tagline="Write. Edit. Pitch. Publish."
      />

      {/* 2. Felsefe ve Giriş */}
      <section className="course-intro-section py-5">
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={10} lg={8}>
              <h2 className="cb-title mb-4">A Journey, Not Just a Course</h2>
              <p className="lead text-muted mb-4">
                This course isn’t just about publishing a book; it’s a creative journey where we walk beside you every step of the way.
              </p>
              <p>
                We believe in nurturing authors, not just manuscripts. From the moment you join, you’ll be part of a supportive community that celebrates your milestones, uplifts your creativity, and continues to guide you even after your book is published.
              </p>
              <div className="quote-box mt-4 p-4 bg-light rounded">
                <p className="fst-italic mb-0">
                  "When you join Little Hibba, you don’t just create a book. You grow as a storyteller. You build confidence. You become part of a family of dreamers who turn imagination into reality."
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* 3. Eğitmen Bölümü */}
      <section className="instructor-section py-5 bg-light-section">
        <Container>
          <Row className="align-items-center">
            <Col md={5} className="mb-4 mb-md-0">
              <img 
                src="/images/prof.jpg" 
                alt="Dr Wendy O’Shea-Meddour" 
                className="img-fluid rounded shadow-lg"
                style={{ width: '100%', objectFit: 'cover' }}
              />
            </Col>
            <Col md={7}>
              <span className="badge bg-primary mb-2">Lead Instructor</span>
              <h2 className="mb-3">Dr Wendy O’Shea-Meddour</h2>
              <h5 className="text-muted mb-4">(MA, PhD, FHEA)</h5>
              <p className="lead">
                Award-winning Children’s Author and Professor of Creative Writing.
              </p>
              <p>
                We have proudly helped hundreds of authors bring their ideas to life. Under Dr. Wendy's expert guidance, this 6-week course is designed to assist you in writing, editing, and preparing your pitch, or to pursue self-publishing independently.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* 4. Kurs Detayları ve FİYAT KARTI (CTA BURADA) */}
      <section className="course-features-section py-5">
        <Container>
          <div className="text-center mb-5">
            <h2 className="cb-title">Start Your Journey</h2>
            <p className="text-muted">Everything you need to turn your idea into a book.</p>
          </div>
          
          <Row className="g-4">
            <Col lg={7}>
              <div className="features-grid">
                {[
                  "6 weeks of lessons & live calls",
                  "Live Editing sessions",
                  "Worksheets, templates, and bonus guides",
                  "Lifetime access to content",
                  "Access to recordings of live calls",
                  "Dedicated Q/A sessions",
                  "Become part of the Little Hibba Community"
                ].map((item, index) => (
                  <div key={index} className="d-flex align-items-center mb-3">
                    <i className="bi bi-check-circle-fill text-success me-3 fs-4"></i>
                    <span className="fs-5">{item}</span>
                  </div>
                ))}
              </div>
            </Col>

            <Col lg={5}>
              {/* GÜNCELLENDİ: Kart Metin Renkleri Görsele Göre Ayarlandı */}
              <Card className="border-0 shadow-sm h-100 bg-primary position-relative overflow-hidden">
                <Card.Body className="d-flex flex-column justify-content-center text-center p-5">
                  {/* Başlık Koyu Renk */}
                  <h3 className="mb-4 text-dark">Course Logistics</h3>
                  
                  <div className="mb-4">
                    {/* Alt Başlık Turuncu/Gold */}
                    <h6 className="text-warning fw-bold text-uppercase">Starts From</h6>
                    {/* Tarih Koyu Renk */}
                    <h4 className="text-dark">8th January 2026</h4>
                  </div>

                  <div className="mb-4">
                    {/* Alt Başlık Turuncu/Gold */}
                    <h6 className="text-warning fw-bold text-uppercase">Timings</h6>
                    {/* Gün Koyu Renk */}
                    <h4 className="text-dark">Every Thursday</h4>
                    {/* Saat Beyaz */}
                    <p className="text-white mb-0">6:30 - 8:00 PM</p>
                  </div>

                  <hr className="bg-white opacity-25" />

                  <div className="mb-4">
                    {/* Alt Başlık Turuncu/Gold */}
                    <h6 className="text-warning fw-bold text-uppercase">Full Payment</h6>
                    {/* Fiyat Koyu Renk */}
                    <h2 className="display-4 fw-bold text-dark">£899</h2>
                  </div>

                  {/* ANA CTA BUTTONU */}
                  <Button 
                    href={checkoutUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="light" 
                    size="lg" 
                    className="w-100 text-primary fw-bold py-3 shadow-sm"
                  >
                    Secure Your Spot Now
                  </Button>
                  {/* Alt not Beyaz */}
                  <small className="mt-3 text-white d-block">Limited seats available</small>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* 5. Bonus ve Kurucu Bölümü */}
      <section className="founder-section py-5 bg-light">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col md={10}>
              <div className="alert alert-warning border-0 shadow-sm d-flex align-items-center p-4 rounded-3" role="alert">
                <div className="me-4 fs-1">🎁</div>
                <div>
                  <h4 className="alert-heading fw-bold mb-1">EXCLUSIVE BONUS</h4>
                  <p className="mb-0">
                    Get a <strong>FREE 1:1 mentoring session</strong> on your illustration plan and book development with Sajeda Faraz.
                  </p>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="align-items-center flex-md-row-reverse">
            <Col md={5} className="mb-4 mb-md-0 text-center">
              <img 
                src="/images/sajeda.jpg" 
                alt="Sajeda Faraz" 
                className="img-fluid rounded-circle shadow border border-5 border-white"
                style={{ width: '300px', height: '300px', objectFit: 'cover' }}
              />
            </Col>
            <Col md={7}>
              <h3 className="mb-2">Meet Your Mentor: Sajeda Faraz</h3>
              <p className="text-primary fw-bold mb-3">Founder and CEO of Little Hibba</p>
              <p>
                Little Hibba was born in 2011, when Sajeda began searching for engaging, colourful Islamic books for her little one. She created Little Hibba to offer personalised Islamic picture books for children.
              </p>
              <p className="fst-italic text-muted">
                Currently pursuing her Master's in Children’s Publishing from Bath Spa University.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* 6. SON ÇAĞRI (FINAL CTA) */}
      <section className="final-cta py-5 text-center">
        <Container>
          <Row className="justify-content-center">
            <Col md={8}>
              <h2 className="mb-4">Ready to Write Your Story?</h2>
              <p className="lead mb-4">
                Join the Little Hibba Picture Book Course and turn your imagination into reality.
              </p>
              <Button 
                href={checkoutUrl}
                target="_blank"
                rel="noopener noreferrer"
                variant="primary" 
                size="lg" 
                className="px-5 py-3 rounded-pill fw-bold shadow"
              >
                Enroll Now for £899
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Course;